// @flow
import type { RouteType } from "../types";

const Routes: Array<RouteType> = [
  {
    key: "home",
    name: "Racing",
    path: "/home",
    exact: false
  },
  {
    key: "tracks",
    name: "Tracks",
    path: "/tracks",
    exact: false,
    toggle: "tracksPageOld"
  },
  {
    key: "racetracks",
    name: "Racetracks",
    path: "/racetracks"
  },
  {
    key: "tracksPage",
    name: "Tracks",
    path: "/tracks",
    exact: false,
    toggle: "tracksPageNew"
  },
  {
    key: "tracksPage",
    name: "Tracks",
    path: "/tracks/results",
    exact: false,
    toggle: "tracksPageNew"
  },
  {
    key: "tracksPage",
    name: "Tracks",
    path: "/tracks/all-info",
    exact: false
  },
  {
    key: "tutorials",
    name: "Tutorials",
    path: "/tutorials",
    exact: false
  },
  {
    key: "results",
    name: "Results",
    path: "/results",
    exact: false
  },
  {
    key: "live",
    name: "Live",
    path: "/live",
    exact: true
  },
  {
    key: "redirectEngine",
    name: "redirectEngine",
    path: "/redirectEngine",
    exact: true
  },
  {
    key: "picks",
    name: "Picks",
    path: "/handicapping/talent-picks",
    exact: true
  },
  {
    key: "account",
    name: "Account",
    path: "/account"
  },
  {
    key: "programPage",
    path: "/racetracks/:trackAbbr/:trackName"
  },
  {
    key: "programPageOld",
    path: "/racetracks/:trackAbbr/:trackName/:raceNumber"
  },
  {
    key: "liveProgramPage",
    path: "/live/:channel/:trackAbbr/:trackName"
  },
  {
    key: "liveProgramPageOld",
    path: "/live/:channel/:trackAbbr/:trackName/:raceNumber"
  },
  {
    key: "programPageGreyhoundsWithoutName",
    path: "/greyhounds/:trackAbbr",
    exact: true
  },
  {
    key: "programPageGreyhounds",
    path: "/greyhounds/:trackAbbr/:trackName"
  },
  {
    key: "programPageGreyhoundsOld",
    path: "/greyhounds/:trackAbbr/:trackName/:raceNumber"
  },
  {
    key: "wagerRewards",
    path: "/wager-rewards",
    toggle: "wagerRewardsApp"
  },
  {
    key: "optedin",
    path: "/opted-in"
  },
  {
    key: "emailUnsubscribe",
    path: "/unsubscribe",
    toggle: "useEmailUnsubscribe"
  },
  {
    key: "emailSubscribe",
    path: "/subscribe",
    toggle: "useEmailSubscribe"
  },
  {
    key: "default",
    path: "/"
  },
  {
    key: "redirect",
    path: "*"
  }
];

export default Routes;
